export default __webpack_public_path__ + "static/the-differance-is-clear-en_converted-6131cc1357d978bbbe874cb4ec806c21.mp4";